import { getCookie } from 'cookies-next';

import { Tokens } from '../types';
import { clientAxios } from '../api';
import { PATH } from '../constants';

import { decrypt, encrypt } from './crypto';
import { decodeJwt } from './jwt';
import ClientAuth from './ClientAuth';

class Auth {
  static encodingToken({ accessToken, refreshToken }: Tokens) {
    const tokens = { accessToken, refreshToken };
    const stringifiedTokens = JSON.stringify(tokens);

    return encrypt(stringifiedTokens);
  }

  static decodingToken(encodedTokens: string | null) {
    if (!encodedTokens) return null;
    const decodedTokens = decrypt(encodedTokens);

    return JSON.parse(decodedTokens);
  }

  static getExpiredTime(encodedTokens: string | null) {
    if (!encodedTokens)
      return { accessTokenExpiredTime: null, refreshTokenExpiredTime: null };

    const tokens = Auth.decodingToken(encodedTokens);
    const getRemainExpiredTime = (token: string): number => {
      const payload = decodeJwt(token);
      if (!payload) return 0;

      const { exp } = payload;

      return exp ? exp * 1000 : 0;
    };

    const accessTokenExpiredTime = getRemainExpiredTime(tokens.accessToken);
    const refreshTokenExpiredTime = getRemainExpiredTime(tokens.refreshToken);

    return { accessTokenExpiredTime, refreshTokenExpiredTime };
  }

  static getDomain() {
    const stage = process.env.NEXT_PUBLIC_APP_STAGE;
    if (stage === 'prod') return '.wishket.com';
    if (stage === 'stag') return '.wishdev.net';
    if (stage === 'dev') return '.wishdev.net';

    return 'localhost';
  }

  static getRefreshToken() {
    const encodedTokens = ClientAuth.getWART();

    if (!encodedTokens) return null;

    const tokens = Auth.decodingToken(encodedTokens);

    if (!tokens) return null;

    return tokens.refreshToken;
  }

  static async refreshAccessToken() {
    try {
      const WART = getCookie('WART');
      if (!WART) return null;

      const wsessionid = getCookie('wsessionid');
      if (!wsessionid) return null;

      const { data } = await clientAxios.put(
        `${PATH.WISHKET_OIDC_URL}?wishketOidcOrigin=${encodeURIComponent(process.env.NEXT_PUBLIC_APP_BASE_URL || '')}`,
        {},
        {
          headers: {
            cookie: `WART=${WART};wsessionid=${wsessionid}`,
          },
          withCredentials: true,
        }
      );

      return data.ok;
    } catch (e) {
      return null;
    }
  }
}

export default Auth;
